import React from "react";

import Heading from "../../components/Heading";

const latestPostId = "CyzCEYNLfhP"; // 19th June 2024

export default function HomeInsta() {
  return (
    <section className="text-center">
      <Heading as="h2" className="p-10 text-2xl md:text-3xl md:p-14">
        INSTAGRAM
      </Heading>
      <iframe
        id="instagram-embed-0"
        src={`https://www.instagram.com/p/${latestPostId}/embed/captioned`}
        allowTransparency
        allowFullScreen
        height="1100"
        title="Instagram"
        className="w-full mx-auto max-w-[500px] rounded-lg drop-shadow-[0_0_2px_#aaa] mb-8"
      ></iframe>
    </section>
  );
}
